<app-pdftron #pdfViewer [url]="documentBlob"></app-pdftron>
